import { render, staticRenderFns } from "./AppServers.vue?vue&type=template&id=4fb06fa8&scoped=true&lang=pug&"
import script from "./AppServers.vue?vue&type=script&lang=js&"
export * from "./AppServers.vue?vue&type=script&lang=js&"
import style0 from "./AppServers.vue?vue&type=style&index=0&id=4fb06fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb06fa8",
  null
  
)

export default component.exports